import script from "./CardPlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardPlaceholder.vue?vue&type=script&setup=true&lang=ts"

import "./CardPlaceholder.vue?vue&type=style&index=0&id=d5a7063a&lang=css"

const __exports__ = script;

export default __exports__